import { assert } from './assert.js';

/**
 * Creates a random UUID v4
 * @returns UUIDv4
 */
export function createUUIDv4(): string {
  assert(
    typeof crypto.randomUUID === 'function',
    'Invalid function: randomUUID not available.',
  );
  return crypto.randomUUID();
}

/**
 * Creates a UUID v3 from input entropy
 * @returns UUIDv3
 */
export async function createUUIDv3(input: string): Promise<string> {
  assert(
    typeof input === 'string' && input.length > 0,
    'Invalid input argument: not a valid string',
  );

  // Convert input
  const inputBytes = new TextEncoder().encode(input);
  const digestedHash = await crypto.subtle.digest('SHA-256', inputBytes);
  const hashBytes = new Uint8Array(digestedHash);

  // Set bytes to match uuid version
  hashBytes[6] = (hashBytes[6] & 0x0f) | 0x30; // Set version to 3
  hashBytes[8] = (hashBytes[8] & 0x3f) | 0x80; // Set variant to RFC4122

  // Convert to string
  const uuidHex = Array.from(hashBytes)
    .map((byte) => {
      return byte.toString(16).padStart(2, '0');
    })
    .join('');

  // Create uuid from hex
  return [
    ...uuidHex.slice(0, 8),
    '-',
    ...uuidHex.slice(8, 12),
    '-',
    ...uuidHex.slice(12, 16),
    '-',
    ...uuidHex.slice(16, 20),
    '-',
    ...uuidHex.slice(20, 32),
  ].join('');
}
